import { Injectable } from '@angular/core';
import { AmplitudeService } from './amplitude.service';
import { 
  PqrsEvent, 
  NewPqrsStarted, 
  NewPqrsCreated, 
  PqrsFilterUsed, 
  PqrsOpened,
  UserLogOut,
  PasswordUpdated,
  UserLogin,
  HomeViewed
} from '../../analytics/pqrs-events';

@Injectable({
  providedIn: 'root'
})
export class PqrsAmplitudeService extends AmplitudeService {

  constructor() { 
    super();
  }

  sendNewPqrsStarted(eventProperties: NewPqrsStarted): void {
    this.logEvent(PqrsEvent.newPqrsStarted, eventProperties);
  }

  sendNewPqrsCreated(eventProperties: NewPqrsCreated): void {
    this.logEvent(PqrsEvent.newPqrsCreated, eventProperties);
  }

  sendPqrsFilterUsed(eventProperties: PqrsFilterUsed): void {
    this.logEvent(PqrsEvent.pqrsFilterUsed, eventProperties);
  }

  sendPqrsOpened(eventProperties: PqrsOpened): void {
    this.logEvent(PqrsEvent.pqrsOpened, eventProperties);
  }

  sendUserLogOut(eventProperties: UserLogOut, userId?: string): void {
    if (userId) {
      this.logEventWithUserId(PqrsEvent.userLogOut, eventProperties, userId);
    } else {
      this.logEvent(PqrsEvent.userLogOut, eventProperties);
    }
  }

  sendPasswordUpdated(eventProperties: PasswordUpdated): void {
    this.logEvent(PqrsEvent.passwordUpdated, eventProperties);
  }
  
  sendUserLogin(eventProperties: UserLogin): void {
    this.logEvent(PqrsEvent.userLogin, eventProperties);
  }

  sendHomeViewed(eventProperties: HomeViewed): void {
    this.logEvent(PqrsEvent.homeViewed, eventProperties);
  }
}
